import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import CheckLogin from './CheckLogin'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import axios from 'axios'

export default function Sidebar() {
const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const corporate_customer=sessionStorage.getItem('corporate_customer')
const API_PATH=`${SERVER_URL}login.php`;

const navigate=useNavigate()
const get_userid=sessionStorage.getItem('userid')
if(get_userid =="" || get_userid =="0"){
  navigate('/login');
}

useEffect(() => {

  if (sessionStorage.getItem('userid') == "" || sessionStorage.getItem('userid') < 0 || sessionStorage.getItem('userid') == 0 || sessionStorage.getItem('userid') === null) {
    navigate('/login');
  }
  /*
  else{

    if(sessionStorage.getItem('username') !="" && sessionStorage.getItem('password') !=""){
      const tryValidate = {
        username: sessionStorage.getItem('username'),
        password: sessionStorage.getItem('password')
      }
        axios({
            method: 'post',
            url: `${API_PATH}`,
            data: tryValidate
        })
        .then((res)=>
        {
          //console.log(res.data)
          if(res.data.userid != sessionStorage.getItem('userid')){
            //console.log("Reilan");            
            navigate('/login');
          }
        }
        )
        .catch((err)=>console.log(err))
    }
  }
    */
  
}, [])
//console.log(sessionStorage.getItem('username'));
  return (
    <div id="admin-sidebar" className="col-md-3 p-x-0 p-y-3 sidebar">
       <CheckLogin />
    <ul className="sidenav admin-sidenav list-unstyled">
      <li><NavLink to="/my-account/my-parcels">MY PARCELS</NavLink></li>
      <li><NavLink to="/my-account/quick-quote">QUOTE PACKAGE</NavLink></li>
      <li><NavLink to="/my-account/document-quote">QUOTE DOCUMENT</NavLink></li>
      <li><NavLink to="/my-account/domestic-quote">QUOTE DOMESTIC</NavLink></li>
      {corporate_customer && corporate_customer>0?(
        <li><NavLink to="/my-account/bulk-upload/">BULK UPLOAD</NavLink></li>  
      ):null}  
      <li><NavLink to="/track">TRACK</NavLink></li>
      <li><NavLink to="/my-account/my-wallet/">MY WALLET</NavLink></li>  
      {/* <li><NavLink to="/my-account/my-subscriptions/">MY SUBSCRIPTIONS</NavLink></li>                   */}
      <li><NavLink to="/my-account/address-book">ADDRESS BOOK</NavLink></li>                  
   
      <li><NavLink to="/my-account/settings">SETTINGS</NavLink></li>      
    </ul>

  </div> 
  )
}
